/* Let same-page links reach the product list after closing the native menu. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-oww-house-all], header a[href*="#"], .oww-hub a[href*="#"]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
  const isWashFamily = ['#wassen', '#vlekken-behandelen', '#drogen-ophangen', '#strijken'].includes(url.hash) || /^#oww-wasgoed-family-[0-4]$/.test(url.hash);
  if (!link.matches('[data-oww-house-all]') && !isWashFamily) return;
  if (isWashFamily) {
    document.querySelector('oww-wasgoed-preview')?.dispatchEvent(new CustomEvent('oww:family-anchor', { detail: { hash: url.hash } }));
  }
  const fragmentTarget = document.getElementById(url.hash.slice(1));
  const target = fragmentTarget?.matches('[data-wasgoed-heading]') ? fragmentTarget.querySelector('h2') : fragmentTarget;
  if (!target) return;
  event.preventDefault();
  const drawer = link.closest('header-drawer, menu-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, target);
    drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
  link.closest('header-menu')?.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start', behavior: 'instant' });
});
